// src/routes/permisos.js
//
// Qué pantalla puede ver cada rol.
//
// Está acá y no repartido por los componentes a propósito: si mañana el lector
// tiene que ver además el Status de Autorización, se mueve una constante en
// este archivo. Sin eso, la alternativa termina siendo inventar roles nuevos
// (COMP_LECTOR_INFORMES y compañía) para cada combinación.
//
// OJO: esconder el menú y bloquear la ruta es comodidad, no seguridad. El
// permiso de verdad lo aplica el backend en cada endpoint. Esto evita que
// alguien vea opciones que le van a dar 403, y que llegue por URL a una
// pantalla que después le va a fallar a pedazos.
import { ROLES } from '../hooks/useAuth';

const { SUPER, ADMIN, COMPRADOR, LECTOR } = ROLES;

/** Roles que operan: todo menos el lector. */
const OPERAN = [SUPER, ADMIN, COMPRADOR];

/** Todos los roles del portal. */
const TODOS = [SUPER, ADMIN, COMPRADOR, LECTOR];

/**
 * Ruta → roles habilitados.
 *
 * El lector ve el dashboard y la consignación. La consignación se lo permite
 * porque la pantalla es de consulta: el botón de generar la orden ya está
 * protegido aparte, y el endpoint también.
 *
 * Queda afuera el Status de Autorización, que expone montos, solicitantes y
 * cadena de firmas de las cinco empresas, y el Asistente de Reclamos, que es
 * operación pura.
 */
export const PANTALLAS = {
  '/dashboard':            TODOS,
  '/consignacion':         TODOS,

  '/compras/solicitudes':  OPERAN,
  '/compras/ordenes':      OPERAN,
  '/compras/intercompany': OPERAN,
  '/compras/centros-costo':OPERAN,

  '/articulos':            OPERAN,
  '/articulos/importador': OPERAN,
  '/articulos/actualizar':  OPERAN,

  '/informes/reclamos':    OPERAN,
  '/informes/pendientes':  OPERAN,
  '/informes/status':      OPERAN,

  '/notificaciones':       OPERAN
};

/** Pantalla a la que se manda a quien entra a una ruta que no le corresponde. */
export const RUTA_POR_DEFECTO = '/dashboard';

/** ¿Los roles del usuario habilitan esta ruta? */
export function puedeVer(ruta, roles = []) {
  const permitidos = PANTALLAS[ruta];
  // Una ruta que no está en el mapa se trata como restringida: es preferible
  // que una pantalla nueva quede inaccesible por olvido a que quede abierta.
  if (!permitidos) return false;
  return roles.some(r => permitidos.includes(r));
}
